<template>
  <div
    class="price-catalog d-flex flex-column"
    :class="isMobile ? 'ga-6' : 'ga-8'"
  >
    <MedflexList
      v-if="hasMedflexUi && (serviceClasses.length > 0 || isNotFound)"
      :service-classes="serviceClasses"
      :lpu-id="lpuId"
      :town-translit="townTranslit"
      :town-timedelta="townTimedelta"
      :is-enabled-direct="isEnabledDirect"
      :is-not-found="isNotFound"
      :show-all-button="showAllButton"
      :empty-src="emptySrc"
      :hide-group-titles="hideGroupTitles"
      @show-all="$emit('show-all')"
    />
    <div
      v-if="hasMedflexApi && showPagination"
      class="price-catalog__pagination"
    >
      <PagePagination
        color="var(--lpu-branding-color-primary)"
        :current-page="currentPage"
        :pages-length="pageCount"
        :mobile="isMobile"
        scroll-to-selector="#prices"
        data-qa="lpu_services_pagination"
        @input="$emit('page-input', $event.pageNumber)"
      />
    </div>
    <ManualList
      v-if="specialities.length || categories.length"
      :lpu="lpu"
      :specialities="specialities"
      :categories="categories"
    />
  </div>
</template>

<script lang="ts" setup>
import useIsMobile from 'src/composables/useIsMobile'
import PagePagination from 'src/components/common/PagePagination/PagePagination.vue'
import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'
import type {
  DiagnosticPriceCategory,
  SpecialityPricelistItem,
} from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceCatalog/types'
import type { MedflexServiceClass } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/types/medflex'
import MedflexList from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceCatalog/MedflexList.vue'
import ManualList from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceCatalog/ManualList.vue'

type Emits = {
  (_event: 'show-all'): void
  (_event: 'page-input', _pageNumber: number): void
}

defineProps<{
  hasMedflexUi: boolean
  hasMedflexApi: boolean
  showPagination: boolean
  showAllButton: boolean
  isNotFound: boolean
  isEnabledDirect: boolean
  hideGroupTitles: boolean
  serviceClasses: MedflexServiceClass[]
  specialities: SpecialityPricelistItem[]
  categories: DiagnosticPriceCategory[]
  lpu: Lpu
  lpuId: number
  townTranslit: string
  townTimedelta: number
  emptySrc: string
  currentPage: number
  pageCount: number
}>()

defineEmits<Emits>()

const isMobile = useIsMobile()
</script>

<style scoped lang="scss">
.price-catalog {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.price-catalog__pagination {
  ::v-deep .v-pagination__item--active {
    background-color: var(--lpu-branding-color-primary) !important;
    border-color: var(--lpu-branding-color-primary) !important;
  }

  ::v-deep .v-pagination__navigation .v-icon {
    color: var(--lpu-branding-color-primary);
  }
}
</style>
